/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import injectSheet from 'react-jss';

import { useSelector, useDispatch } from 'react-redux';
import usePrevious from 'hooks/usePrevious';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTrophy } from '@fortawesome/free-solid-svg-icons';

import MatchMStyles from './MatchM_Styles';

import { getPick, getTeamsFromPicks, getMatchupFromPicks } from '../../../redux/features/picks/picks';
import { setPick } from '../../../redux/features/picks/picksSlice';

import Gauge from './Gauge';
import TeamStats from './TeamStats';

const styles = MatchMStyles;

const MatchM = ({
  classes,
  teamz,
  id,
  roundName,
}) => {
  const dispatch = useDispatch();

  const teams = useSelector((state) => getTeamsFromPicks(state, teamz));

  const matchup = useSelector((state) => getMatchupFromPicks(state, teamz));
  const pick = useSelector((state) => getPick(state, id));
  const loserPick = useSelector((state) => getPick(state, `L${id.slice(1, 3)}`));

  const handlePick = (_pick, teamId) => {
    dispatch(setPick({ ..._pick, teamId }));
  };

  const makePick = (_pick, teamId) => {
    dispatch(setPick({ ..._pick, teamId }));
  };

  const clearPick = (_pick) => {
    dispatch(setPick({ ..._pick, teamId: null }));
  };

  const previousProps = usePrevious({ teams, pick, loserPick });

  useEffect(() => {
    if (previousProps && pick.teamId) {
      // 1st
      if (
        pick.teamId
        && !teams.map((team) => team.id).includes(pick.teamId)
      ) { // eslint-disable-line max-len
        clearPick(pick);
        clearPick(loserPick);
      }

      // 2nd
      if (
        loserPick
        && pick.teamId !== previousProps.pick.teamId
        && previousProps.teams.find((team) => team.id !== pick.teamId).id
      ) { // eslint-disable-line max-len
        const loserTeamId = previousProps.teams.find((team) => team.id !== pick.teamId).id;
        clearPick(loserPick);
        makePick(loserPick, loserTeamId);
      }

      // 3rd
      if (
        previousProps.loserPick
      && previousProps.pick.teamId
      && teams.find((team) => team.id !== previousProps.pick.teamId).id
      && previousProps.teams.find((team) => team.id !== previousProps.pick.teamId).id !== teams.find((team) => team.id !== previousProps.pick.teamId).id // eslint-disable-line max-len
      ) {
        const loserTeamId = teams.find((team) => team.id !== pick.teamId).id;
        makePick(loserPick, loserTeamId);
      }

      // 4th
      // ISSUE HERE - WHERE LOSER PICK GET CLEARED EVEN IF WE CHOOSE ONE DIFFERENT TEAM FROM THE SEMIFINALS -
      // CORRECT BEHAVIOR IS FOR IT TO CHANGE BASED on 3RD AND NOT CALL 4TH THAT CLEARS IT
      if (
        previousProps.loserPick
        && previousProps.loserPick.teamId
        && previousProps.pick.teamId
        && previousProps.teams.find((team) => team.id !== previousProps.pick.teamId).id !== teams.find((team) => team.id !== previousProps.pick.teamId).id // eslint-disable-line max-len
      ) {
        clearPick(loserPick);
      }
    }
  });

  const handleDialogPick = (_pick, teamId) => () => {
    makePick(_pick, teamId);
  };

  return (
    <div className={classes.cardcontainer}>
      <div className={classes.card}>
        <div className={classes.pronostico}>
          {!!matchup && (
          <div className={classes.intro}>
            <div className={classes.introtitle}>
              <span className={classes.bold}>
                {matchup.chances[0] > matchup.chances[1]
                  ? teams[0].name : teams[1].name}
              </span>
              <span>&nbsp;is more likely to win</span>
            </div>
          </div>
          )}
        </div>
        <div className={classes.dialogbody}>
          <div className={classes.teamsheader}>
            <div
              className={classes.team}
              style={{
                opacity: (() => {
                  if (pick.teamId === teams[1].id) return '0.4';
                  return '1';
                })(),
              }}
            >
              <div
                className={classes.flag}
                onClick={handleDialogPick(pick, teams[0].id || null)}
              >
                <div
                  className={classes.img}
                  style={{
                    background: (() => {
                      if (pick.teamId === teams[0].id) return '#62AD1D';
                      return `url(assets/images/flags/${teams[0].id}.svg)`;
                    })(),
                    opacity: (() => {
                      if (pick.teamId === teams[1].id) return '0.4';
                      return '1';
                    })(),
                  }}
                >
                  <FontAwesomeIcon
                    icon={roundName === 'Final' ? faTrophy : faCheck}
                    style={{
                      color: '#fff',
                      visibility: (() => {
                        if (pick.teamId === teams[0].id) return 'visible';
                        return 'hidden';
                      })(),
                    }}
                  />
                </div>
              </div>
              <div>
                <div className={classes.teamname}>
                  {teams[0].name}
                </div>
              </div>
              <div className={classes.chances}>
                <div className={classes.ball_left} />
                {matchup && (`${(100 * matchup.chances[0]).toPrecision(2)}%`)}
              </div>
            </div>
            <div
              className={classes.team}
              style={{
                opacity: (() => {
                  if (pick.teamId === teams[0].id) return '0.4';
                  return '1';
                })(),
              }}
            >
              <div
                className={classes.flag}
                onClick={handleDialogPick(pick, teams[1].id || null)}
              >
                <div
                  className={classes.img}
                  style={{
                    background: (() => {
                      if (pick.teamId === teams[1].id) return '#F9981D';
                      return `url(assets/images/flags/${teams[1].id}.svg)`;
                    })(),
                    opacity: (() => {
                      if (pick.teamId === teams[0].id) return '0.4';
                      return '1';
                    })(),
                  }}
                >

                  <FontAwesomeIcon
                    icon={roundName === 'Final' ? faTrophy : faCheck}
                    style={{
                      color: '#fff',
                      visibility: (() => {
                        if (pick.teamId === teams[1].id) return 'visible';
                        return 'hidden';
                      })(),
                    }}
                  />
                </div>
              </div>
              <div>
                <div className={classes.teamname}>
                  {teams[1].name}
                </div>
              </div>
              <div className={classes.chances}>
                {matchup && (`${(100 * (matchup.chances[1])).toPrecision(2)}%`)}

                <div className={classes.ball_right} />
              </div>
            </div>
          </div>
          <Gauge
            matchup={matchup}
            gaugew="100%"
            tick="50%"
            gaugeh="8px"
            style={{ marginLeft: '0' }}
            tickcolor="#333"
            tickborder="1px solid #fff"
            teamA={teams[0].name}
            teamB={teams[1].name}
          />
          <div className={classes.teamStats}>
            <div className={classes.left}>
              {!!teams[0].id && <TeamStats team={teams[0]} barstackedwidth="40px" reverse mobile />}
            </div>
            <div className={classes.legend}>
              <div>FIFA Ranking</div>
              <div>Elo Ranking</div>
              <div className={classes.recent}>
                Recent fixtures
                <div className={classes.smalltext}>
                  (2021-2022)
                </div>
              </div>
              <div>Games Played</div>
              <div>Games Won</div>
              <div>Games Drawn</div>
              <div>Games Lost</div>
              <div className={classes.separator} />
              <div>Goals Scored</div>
              <div>Goals Against</div>
            </div>
            <div className={classes.right}>
              {!!teams[1].id && <TeamStats team={teams[1]} barstackedwidth="40px" mobile />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

MatchM.propTypes = {
  classes: PropTypes.object.isRequired,
  teamz: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  roundName: PropTypes.string,
};

MatchM.defaultProps = {
  roundName: '',
};
export default injectSheet(styles)(MatchM);
